import Dashboard from "../components/editor/Dashboard";
import EditorDashboardLayout from "../components/EditorDashboardLayout";

function EditorDashboardPage(){
    return(
       <EditorDashboardLayout>
        <Dashboard/>
       </EditorDashboardLayout> 
    )
}
export default EditorDashboardPage